export const debugOptions = { debug: false };
export function debug(message, logFunction = console.log) {
    if (debugOptions.debug) {
        if (typeof message === 'function') {
            logFunction(`translations: ${message()}`);
        }
        else {
            logFunction(`translations: ${message}`);
        }
    }
}
